import React from 'react'
import SlotCards from './SlotCards'
import SlotList from './SlotList'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'

export default function CleaningSlotsTab ({ cleaningSlots, boxes }) {
  const screens = useBreakpoint()

  return (
    <>
      {screens.xs && <SlotCards slots={cleaningSlots} boxes={boxes} />}
      {!screens.xs && <SlotList slots={cleaningSlots} boxes={boxes} />}
    </>
  )
}
